/*
 * 演示数据的时间基准。
 *
 * mock 数据的日期不写死年月日，而是写成「相对今天偏移 N 天」，在这里统一落到具体日期。
 * 这样无论哪天打开站点，数据的相对位置都一致：不会整批过期，状态分布也恒定。
 *
 * 需要对着某一版截图核对时，把 `demoToday` 换成固定常量（如 `'2026-09-20'`）即可整体冻结。
 */
export const demoToday: string = formatDay(new Date());

export function formatDay(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

/** 日期串统一为 `YYYY-MM-DD`，字典序等于时间序，可直接用 `>` / `<` 比较。 */
export function shiftDays(today: string, offset: number): string {
  const date = new Date(`${today}T00:00:00`);
  date.setDate(date.getDate() + offset);
  return formatDay(date);
}
